import React, { useContext } from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import { ucwords } from '../helper';
import BusinessActivitiesUpdateModal from './BusinessActivitiesUpdateModal';

function BusinessActivities({
  data,
  businessInformation,
  isStartAssessment,
  checkAssessor,
  reassessmentActivities,
  setActivities,
}) {
  const setModal = useContext(ModalContext);
  const permissions = getJson('permissions');
  const finalData =
    get(businessInformation, 'attributes.transaction_type') === 'QUARTERLY' &&
    ['REASSESSING'].indexOf(
      get(businessInformation, 'attributes.transaction_status')
    ) > -1
      ? reassessmentActivities
      : data;
  const handleUpdateBusinessActivities = (dataInfo) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <BusinessActivitiesUpdateModal
          updateList={dataInfo.attributes}
          businessActivity={dataInfo}
          businessInformation={businessInformation}
          checkAssessor={checkAssessor}
          isStartAssessment={isStartAssessment}
        />
      ),
      title: 'Update Business Activities',
      modalSize: 'modal-md',
    });
  };
  const handleUpdateBusinessActivitiesQuarterly = (dataInfo) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <BusinessActivitiesUpdateModal
          updateList={{ ...dataInfo.attributes, id: dataInfo.id }}
          businessActivity={dataInfo}
          businessInformation={businessInformation}
          checkAssessor={checkAssessor}
          isStartAssessment={isStartAssessment}
          setActivities={setActivities}
          reassessmentActivities={reassessmentActivities}
          originalGrossAmount={
            data.find((item) => item.id === dataInfo.id)?.attributes
              ?.gross_amount
          }
        />
      ),
      title: 'Update Business Activities',
      modalSize: 'modal-md',
    });
  };

  return (
    <div className="m-3">
      {finalData.length > 0
        ? finalData.map((businessActivity) => {
            const details = get(businessActivity, 'attributes.details') || {};
            return (
              <div key={businessActivity.id}>
                <table className="transaction-table table table-borderless table-sm">
                  <tbody>
                    <tr>
                      <td className="text-dark" width="250">
                        Name
                      </td>
                      <td className="text-dark" width="1">
                        :
                      </td>
                      <td colSpan={4}>
                        <b>{get(businessActivity, 'attributes.name') || '-'}</b>
                      </td>
                      {['RENEWAL'].indexOf(
                        get(businessInformation, 'attributes.transaction_type')
                      ) > -1 &&
                        get(
                          businessInformation,
                          'attributes.transaction_status'
                        ) === 'FOR CHECKING' &&
                        get(
                          businessInformation,
                          'included.bplsApplication.attributes.status'
                        ) === 'FOR LICENSE ASSESSMENT' &&
                        isStartAssessment === 1 &&
                        checkAssessor() && (
                          <td className="text-right">
                            {Acl(permissions, [
                              'E2E BPLS EDIT ACTIVITY BEFORE SOA',
                            ]) && (
                              <button
                                onClick={handleUpdateBusinessActivities(
                                  // newBusinessesId,
                                  businessActivity
                                )}
                                type="button"
                                className="btn-blank"
                              >
                                <i className="far fa-edit icon-edit" />
                              </button>
                            )}
                          </td>
                        )}
                      {['RENEWAL'].indexOf(
                        get(businessInformation, 'attributes.transaction_type')
                      ) > -1 &&
                        ['PENDING', 'FOR LICENSE ASSESSMENT'].indexOf(
                          get(
                            businessInformation,
                            'attributes.transaction_status'
                          )
                        ) > -1 &&
                        get(
                          businessInformation,
                          'included.bplsApplication.attributes.status'
                        ) === 'COMPUTED' &&
                        checkAssessor() && (
                          <td className="text-right">
                            {Acl(permissions, [
                              'E2E BPLS EDIT ACTIVITY AFTER SOA',
                            ]) && (
                              <button
                                onClick={handleUpdateBusinessActivities(
                                  businessActivity
                                )}
                                type="button"
                                className="btn-blank"
                              >
                                <i className="far fa-edit icon-edit" />
                              </button>
                            )}
                          </td>
                        )}
                      {['QUARTERLY'].indexOf(
                        get(businessInformation, 'attributes.transaction_type')
                      ) > -1 &&
                        ['REASSESSING'].indexOf(
                          get(
                            businessInformation,
                            'attributes.transaction_status'
                          )
                        ) > -1 &&
                        checkAssessor() && (
                          <td className="text-right">
                            {Acl(permissions, [
                              'E2E BPLS QUARTERLY EDIT ACTIVITY AMOUNT',
                            ]) && (
                              <button
                                onClick={handleUpdateBusinessActivitiesQuarterly(
                                  businessActivity
                                )}
                                type="button"
                                className="btn-blank"
                              >
                                <i className="far fa-edit icon-edit" />
                              </button>
                            )}
                          </td>
                        )}
                    </tr>
                    {get(businessInformation, 'attributes.transaction_type') !==
                      'DELINQUENT' && (
                      <>
                        <tr>
                          <td className="text-dark" width="250">
                            Capital Amount
                          </td>
                          <td className="text-dark" width="1">
                            :
                          </td>
                          <td colSpan={4}>
                            <b>
                              {get(
                                businessActivity,
                                'attributes.capital_amount_human'
                              ) || '-'}
                            </b>
                          </td>
                        </tr>
                        <tr>
                          <td className="text-dark" width="250">
                            Gross Amount
                          </td>
                          <td className="text-dark" width="1">
                            :
                          </td>
                          <td colSpan={4}>
                            <b>
                              {get(
                                businessActivity,
                                'attributes.gross_amount_human'
                              ) || '-'}
                            </b>
                          </td>
                        </tr>
                      </>
                    )}
                    {Object.entries(details).map((item) => {
                      return (
                        <tr key={`bpls_business_detail${item[0]}`}>
                          <td className="text-dark" width="250">
                            {ucwords(item[0].replace(/_/g, ' '))}
                          </td>
                          <td className="text-dark" width="1">
                            :
                          </td>
                          <td colSpan={4}>
                            <b>{item[1] || '-'}</b>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                <div>
                  <table className="transaction-table table table-borderless table-sm">
                    <tbody>
                      {get(
                        businessInformation,
                        'attributes.transaction_type'
                      ) === 'DELINQUENT' && (
                        <>
                          <td className="text-dark" width="250">
                            Yearly Gross Amount
                          </td>
                          <td className="text-dark" width="1">
                            :
                          </td>
                          <td>
                            {Object.entries(
                              get(
                                businessActivity,
                                'attributes.yearly_gross_amount'
                              )
                            ).map((x) => {
                              return (
                                <tr>
                                  <td className="text-dark" width="150">
                                    {x[0]}
                                  </td>
                                  <td className="text-dark" width="1">
                                    :
                                  </td>
                                  <td colSpan={4}>
                                    <b>{x[1]}</b>
                                  </td>
                                </tr>
                              );
                            }) || '-'}
                          </td>
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
                <hr />
              </div>
            );
          })
        : null}
    </div>
  );
}

BusinessActivities.defaultProps = {
  data: {},
  reassessmentActivities: {},
  isStartAssessment: 0,
};

BusinessActivities.propTypes = {
  data: PropTypes.instanceOf(Object),
  reassessmentActivities: PropTypes.instanceOf(Object),
  businessInformation: PropTypes.instanceOf(Object).isRequired,
  checkAssessor: PropTypes.instanceOf(Function).isRequired,
  isStartAssessment: PropTypes.number,
  setActivities: PropTypes.instanceOf(Function).isRequired,
};

export default BusinessActivities;
